import Switch from "react-switch";
import { useChats } from "../../hooks/useChats";
import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";

export default function TableViewReviewed({ value, chat, colData, extraData }) {
  const [hasChanges, setHasChanges] = useState(chat?.contextVariables?.["local:changesNotReviewed"]?.length > 0);
  const [state, setState] = useState(value && !hasChanges);
  const { columnsSmartSheetKeys } = useAuth();
  const { updateContext } = useChats();
  const [view, setView] = useState(0);

  useEffect(() => {
    const hasChanges = chat?.contextVariables?.["local:changesNotReviewed"]?.length > 0;
    setHasChanges(hasChanges);
    setState(value && !hasChanges);
  }, [chat?.contextVariables, value]);

  const toggle = async (e) => {
    setState(e);
    if (e) {
      setHasChanges(false);
    }
    await updateContext("reviewed", e, { currentChat: chat, skipHistory: true, skipReassign: true });
  };

  const goToNext = () => {
    const changes = chat?.contextVariables?.["local:changesNotReviewed"];
    const nextChange = changes[view];
    const columnKey = nextChange.variable;
    const element = document.getElementById(`cell_${chat.id}_${columnKey}`);
    if (element) {
      element.scrollIntoView({ inline: "center", block: "nearest" });
      element.classList.add("highlight-change");
      setTimeout(() => {
        element.classList.remove("highlight-change");
      }, 2000);
      setView((view + 1) % changes.length);
    }
  };

  return (
    <div className="review-area">
      <Switch checked={state} onChange={toggle} uncheckedIcon={false} checkedIcon={false} height={24} width={45} />
      {hasChanges && (
        <span
          onClick={goToNext}
          className="material-symbols-outlined notranslate"
          data-tooltip-id="tooltip-table"
          data-tooltip-html={
            "There have been changes after the review: <ul><li>" +
            chat?.contextVariables?.["local:changesNotReviewed"]
              ?.map((change) => columnsSmartSheetKeys.find((c) => c.key === change.variable)?.label)
              .join("</li><li>") +
            "</li></ul>"
          }
        >
          warning
        </span>
      )}
    </div>
  );
}
